import { render, staticRenderFns } from "./GenericListCard.vue?vue&type=template&id=3068a9a0&scoped=true"
import script from "./GenericListCard.vue?vue&type=script&lang=js"
export * from "./GenericListCard.vue?vue&type=script&lang=js"
import style0 from "./GenericListCard.vue?vue&type=style&index=0&id=3068a9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3068a9a0",
  null
  
)

export default component.exports